import {useDispatch, useSelector} from 'react-redux'
import ModalConfirm from '../../../../components/Modals/Generales/ModalConfirm'
import ModalDelete from '../../../../components/Modals/Generales/ModalDelete'
import {State} from '../../../../reducers'
import {
  gc_lc_OpenModalEliminarCliente,
  gc_lc_OpenModalEstatus,
  gc_lc_SetClienteSeleccionado,
  gc_lc_EliminarClienteConfirm,
  gc_lc_ChangeEstatusCliente,
} from '../../../../actions/gestion-cliente/lista-cliente/listaCliente.actions'

const ModalsControlsCliente = () => {
  const {activeEliminar, activeEstatus} = useSelector(
    (state: State) => state.gestionCliente.listarClientes.modales
  )
  const {clienteSeleccionado} = useSelector((state: State) => state.gestionCliente.listarClientes)
  const dispatch = useDispatch()

  const closeModalEliminar = () => {
    dispatch(gc_lc_OpenModalEliminarCliente(false))
    dispatch(gc_lc_SetClienteSeleccionado(null))
  }

  const closeModalEstatus = () => {
    dispatch(gc_lc_OpenModalEstatus(false))
    dispatch(gc_lc_SetClienteSeleccionado(null))
  }

  return (
    <>
      {activeEliminar && (
        <ModalDelete
          title='Eliminar cliente'
          detail={`¿Seguro que quieres eliminar el cliente ${clienteSeleccionado?.nombre}?`}
          messageAction='Eliminar'
          actionDelete={() => dispatch(gc_lc_EliminarClienteConfirm())}
          closeModalDelete={closeModalEliminar}
          Styles={{minWidth: '25%', maxWidth: '700px'}}
        />
      )}

      {activeEstatus && (
        <ModalConfirm
          title={`${clienteSeleccionado?.activo === 'Activo' ? 'Desactivar' : 'Activar'} cliente`}
          detail={`¿Seguro que quieres ${clienteSeleccionado?.activo === 'Activo' ? 'desactivar' : 'activar'} el cliente ${clienteSeleccionado?.nombre}?`}
          actionConfirm={() => dispatch(gc_lc_ChangeEstatusCliente())}
          closeModalConfirm={closeModalEstatus}
        />
      )}
    </>
  )
}

export default ModalsControlsCliente
